import { render, staticRenderFns } from "./vipLv.vue?vue&type=template&id=a3bd65d0&"
import script from "./vipLv.vue?vue&type=script&lang=js&"
export * from "./vipLv.vue?vue&type=script&lang=js&"
import style0 from "./vipLv.vue?vue&type=style&index=0&id=a3bd65d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports